// eslint-disable-next-line import/prefer-default-export
export const shouldShowTopBarSlider = (displaysOn, pathname, hideTopBarSlider) => {
  const urlParams = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : null
  // If on cart or checkout, or if the filter param is outlet, or if the pathname includes /outlet, hide
  if (hideTopBarSlider || urlParams?.get('filters') === 'outlet' || pathname.includes('outlet')) return false
  const plpPages = ['furniture', 'mattress', 'search']
  const normalizedPath = pathname.toLowerCase()
  if (displaysOn?.includes('home') && displaysOn?.includes('plp') && displaysOn?.includes('pdp')) return true
  const isPlpPage = plpPages.some(keyword => normalizedPath.includes(keyword))
  const isPdpPage = normalizedPath.includes('product')
  if (isPdpPage) {
    return displaysOn?.includes('pdp')
  }
  if (isPlpPage) {
    return displaysOn?.includes('plp')
  }
  return displaysOn?.includes('home')
}
